export const getColors = (colorNames, colorsData) => {
  let matchedColorsArr = [];
  colorsData?.map((color) =>
    colorNames?.map((colorName) => {
      if (color.name === colorName) {
        matchedColorsArr.push(color);
      }
    })
  );

  return matchedColorsArr;
};
